import $ from 'cash-dom';
import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, disablePrevNextBtns } from "./slider-buttons";
import { setupDotBtns, generateDotBtns, selectDotBtn } from "./embla-dot-helpers";

function resolveSlideCountByViewportWidth() {
    const viewWidth = window.innerWidth;

    if (viewWidth >= 1024) {
        return 3;
    } else {
        return 1;
    }
}

$(function () {
    if ($('.video-grid').length != 0) {
        if ($('.video-grid-item').length > 3 || window.innerWidth <= 1023) {
            const sliderParent = document.querySelector('.video-grid-wrapper');
            const sliderNode =  sliderParent.querySelector('.video-grid-container');
            const options = {
                loop: false,
                align: 'center',
                containerSelector: '.video-grid-items',
                slidesToScroll: resolveSlideCountByViewportWidth()
            };

            const prevSlide = sliderParent.querySelector(".embla__button--prev");
            const nextSlide = sliderParent.querySelector(".embla__button--next");

            const slider = EmblaCarousel(sliderNode, options)
            const disablePrevAndNextBtns = disablePrevNextBtns(prevSlide, nextSlide, slider);
            const dotsFeatured = sliderParent.querySelector('.embla__dots');
            prevSlide.style.display = "block";
            nextSlide.style.display = "block";
            dotsFeatured.style.display = "block";
            let dotsFeaturedArr = generateDotBtns(dotsFeatured, slider);
            let setSelectedDotBtn = selectDotBtn(dotsFeaturedArr, slider);

            setupDotBtns(dotsFeaturedArr, slider);
            slider.on('select', setSelectedDotBtn);
            slider.on('init', setSelectedDotBtn);

            setupPrevNextBtns(prevSlide, nextSlide, slider);
            slider.on('select', disablePrevAndNextBtns);
            slider.on('init', disablePrevAndNextBtns);
        }

        $('.item-video').each(function() {
            var container = $(this);

            if (container.find('.video').length != 0) {
                container.find('.play-button').on('click', function () {
                    $(this).css('display', 'none');
                    container.find('.video').get(0).play();
                })
            } else if (container.find('.embed-container').length != 0) {
                container.find('.play-button').on('click', function () {
                    $(this).css('display', 'none');
                    container.find('iframe')[0].src += '&autoplay=1'
                })
            }
        })
    }
})